import { GET_NUMBER_OF_CREATED_AND_RESOLVED_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getNumberOfCreatedAndResolvedDataByQuarterAPI = async (year: number, quarter: number): Promise<any[]> => {
    const response = await axios.get(`${GET_NUMBER_OF_CREATED_AND_RESOLVED_DATA_API}/${year}/${quarter}`);
    return response.data;
};
